import { render, staticRenderFns } from "./StatisticAlanalysis.vue?vue&type=template&id=ab9d3684&scoped=true&"
import script from "./StatisticAlanalysis.vue?vue&type=script&lang=js&"
export * from "./StatisticAlanalysis.vue?vue&type=script&lang=js&"
import style0 from "./StatisticAlanalysis.vue?vue&type=style&index=0&id=ab9d3684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9d3684",
  null
  
)

export default component.exports